import { FileDetails } from "../../app/features/AboutCourse/WorkingPapers/fileDetails";
const FileDetailsPage = () => {
  return <FileDetails />;
};

export default FileDetailsPage;
